module.exports = __webpack_public_path__ + "static/media/minidegreez.68227323.svg";